<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider v-slot="{ valid, errors }" name="status" rules="required">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="formData.status"
                                           :options="statusOptions"
                                           :state="errors[0] ? false : null"
                            />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" v-if="formData.status === 'declined'">
                    <ValidationProvider name="reason" :rules="formData.status === 'declined' ? 'required' : ''" v-slot="{valid, errors}">
                        <b-form-group :label="$t('reason')">
                            <b-form-textarea no-resize rows="4" class="h-40 h-auto-sm" maxlength="100"
                                             v-model="formData.reason"></b-form-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <processing-button :label="$t('save')" :processing="formLoading" @click="updateForm"/>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
// Services
import MentoraTimeOffRequestFormServices from "@/services/MentoraTimeOffRequestFormServices";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"


export default {
    components: {
        ProcessingButton,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        },
        activeStep: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            formData: {
                status: null,
                reason: null,
            },
            formLoading: false,
            statusOptions: [
                {value: null, text: this.$t('select')},
                {value: 'approved', text: this.$t('approved')},
                {value: 'declined', text: this.$t('declined')},
            ],
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$swal.fire({
                    title: this.$t('warning'),
                    text: this.$t('leave_of_absence_statement'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no'),
                }).then((result) => {
                    if (result.isConfirmed) {
                        const payload = {
                            status: this.formData.status,
                        }

                        if (this.formData.status === 'declined') {
                            payload.reason = this.formData.reason
                        }

                        this.formLoading = true
                        MentoraTimeOffRequestFormServices.updateStep(this.activeStep.id, payload)
                            .then(response => {
                                this.$emit('updateFormSuccess', true);
                                this.$toast.success(this.$t('api.' + response.data.message));
                            })
                            .catch(error => {
                                this.showErrors(error, this.$refs.formModalValidate)
                            })
                            .finally(() => {
                                this.formLoading = false
                            });
                    }
                })
            }
        }
    }
}
</script>
